let accessToken = null;

const normalizeToken = (token) => {
    if (typeof token !== "string") {
        return null;
    }
    const trimmed = token.trim();
    return trimmed.length > 0 ? trimmed : null;
};

export const setAccessToken = (token) => {
    accessToken = normalizeToken(token);
};

export const setAccessTokenFromResponse = (data) => {
    if (!data || typeof data !== "object") {
        return;
    }
    const token = data.accessToken || data.token;
    setAccessToken(token);
};

export const getAccessToken = () => accessToken;

export const clearAccessToken = () => {
    accessToken = null;
};

export const buildAuthHeaders = () => {
    if (!accessToken) {
        return {};
    }
    return { Authorization: `Bearer ${accessToken}` };
};

export const mergeAuthHeaders = (headers = {}) => ({
    ...buildAuthHeaders(),
    ...(headers || {}),
});
